// extracted by mini-css-extract-plugin
export var label = "_cz-5";
export var slideContainer = "_cz-0";
export var slider = "_cz-1";
export var sliderLg = "_cz-4";
export var sliderMd = "_cz-3";
export var sliderSm = "_cz-2";